import React, { createContext, useState } from "react";

// Create the LoadingContext
export const LoadingContext = createContext();

// Create a Provider component
export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false); // Define state for loading

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
